import layout from '@/views/common/layout'
const customerRoute = [
    {
        path: '/yd',
        component: layout,
        children: [
            {
                path: 'customerList',
                component: () => import('@/views/yd/customer/customerList'),
                name: 'customerList',
                meta: { title: '客户列表', icon: '', affix: true }
            },
            {
                path: 'customerEdit',
                component: () => import('@/views/yd/customer/customerEdit'),
                name: 'customerEdit',
                meta: { title: '客户编辑', icon: '', affix: true }
            },
            {
                path: 'customerLeaveList',
                component: () => import('@/views/yd/customer/customerLeaveList'),
                name: 'customerLeaveList',
                meta: { title: '留言反馈', icon: '', affix: true }
            },
            {
                path: 'suspendLeaveWord',
                component: () => import('@/views/yd/customer/suspendLeaveWord'),
                name: 'suspendLeaveWord',
                meta: { title: '留言反馈', icon: '', affix: true }
            }
        ]
    },
]

export default customerRoute


// WEBPACK FOOTER //
// ./src/router/modules/customerRouter.js